import { useLayoutEffect } from 'react';
import { useLocation } from 'wouter';

import { destinoDoCheckout, lerCarrinhoAtendimento } from '../utils/carrinho-atendimento';
import { destinoIsolamento, lerVisitaAtendimento } from '../utils/isolamento';
import { readAtendimentoSession } from '../utils/session';

// PRAT-64: a sacola montada no atendimento nunca termina no checkout de
// delivery do app (`/:slug/order`, com entrega/retirada/endereço). Qualquer
// caminho que leve até lá com a sacola do atendimento (sacola do app na loja,
// login por link, histórico do navegador, outra aba) volta para o pagamento do
// atendimento.
//
// E quem está no atendimento nesta aba não cai nas telas do web-app (lojas,
// busca, pedidos, perfil, página da loja): volta para o equivalente dentro do
// atendimento (utils/isolamento). Montado fora das rotas; não desenha nada.
export function AtendimentoCheckoutGuard() {
  const [location, navigate] = useLocation();

  useLayoutEffect(() => {
    const destino =
      destinoDoCheckout(location, lerCarrinhoAtendimento()) ??
      destinoIsolamento(location, readAtendimentoSession(), lerVisitaAtendimento());
    if (destino && destino !== location) navigate(destino, { replace: true });
  }, [location, navigate]);

  return null;
}
